module.exports = __webpack_public_path__ + "static/media/AIE-Letterhead-Footer.84f1805d.jpg";